export const deepseekMandatoryOptions = [
    {
        key: "DeepSeekConversations",
        name: "DeepSeekConversations",
        title: "DeepSeek Conversations ",
        description: "All conversations you’ve had in DeepSeek chatbot.",
        optionPlatform: "deepseek",
        essential: true,         
        payment: "+$5.0",
        type: "standard",
        parent: null,
        use: null,
        warning: "These conversations may contain sensitive personal information. We strongly recommend checking the archive before donation."
    },

]; 


export const deepseekOptionalOptions  = [ 
    
]; 



export const deepseekExcludedOptions  = [



]; 